/* API */
import get from 'lodash/get';
import StorageAPI from 'src/core/utils/StorageAPI';
import { USER_PREFS } from 'vd-constants';

type UserPrefs = Record<string, unknown>;

let lastPrefs: UserPrefs | undefined = undefined;

/**
 *
 * @param {string} name - Feature name
 * @param {*} [defaultValue] - Setting default value (used when setting not found)
 * @returns {*}
 */
const getUserPref = (name: string, defaultValue = undefined) => {
  const preferences = StorageAPI.getLocally(USER_PREFS) || lastPrefs;

  return get(preferences, [name], defaultValue);
};

const updatePrefs = (prefs: UserPrefs) => {
  if (prefs !== lastPrefs) {
    lastPrefs = prefs;
    StorageAPI.storeLocally(USER_PREFS, prefs);
    // featuresEvents.emit('change', features);
  }
};

export default {
  getDefaultLandingPage() {
    return getUserPref('defaultLandingPage');
  },
  updatePrefs,
};
